module.exports = __webpack_public_path__ + "img/1535593679.44f23599.jpg";